export var DEFAULT_CONTAINER_CLASS_NAME = 'continuous-scroll-v2-container';
export var ANIMATION_NAME = 'continuousScrollV2HorizontalAnimation';
export var DEFAULT_INTERSECTION_OBSERVER_THRESHOLD = 0.2;
export var DEFAULT_INTERSECTION_OBSERVER_ROOT_MARGIN = '0px';
export var DEFAULT_ANIMATION_DURATION_SECONDS = 74;
export var DEFAULT_MULTIPLIER = 3;
export var RESTART_ANIMATION_INTERVAL_FACTOR = 0.65;
export var SECONDS_TO_MILLISECONDS = 1000;
export var EAGER_LOAD_STRATEGY = 'eager';
export var IN_VIEWPORT_LOAD_STRATEGY = 'inViewport';
export var CONTINUOUS_SCROLL_LOAD_STRATEGIES = [EAGER_LOAD_STRATEGY, IN_VIEWPORT_LOAD_STRATEGY];
export var DEFAULT_ELEMENT_ALIGNMENT = 'middle';
export var DEFAULT_DEVICE_SETTINGS_MOBILE = {
  gap: 0.75,
  elementWidth: '34vw'
};
export var DEFAULT_DEVICE_SETTINGS_TABLET = {
  gap: 0.95,
  elementWidth: '18vw'
};
export var DEFAULT_DEVICE_SETTINGS_DESKTOP = {
  gap: 1.1,
  elementWidth: '10vw'
};